import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=d921fcda&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=d921fcda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d921fcda",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d921fcda')) {
      api.createRecord('d921fcda', component.options)
    } else {
      api.reload('d921fcda', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=d921fcda&scoped=true&", function () {
      api.rerender('d921fcda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2cE7ROn3Mp21S/JS/comp/SearchFilterTokens.vue"
export default component.exports